import { Unstable_Grid2 as Grid, Stack, TextField } from '@mui/material';

import { Button } from '@occc/ui-design-system';

type SegmentAssignMembershipsProps = {
  shouldDisableControls: boolean;
  membershipInputValue: string;
  onMembershipInputChange: (value: string) => void;
  onAddMembersToSegment: () => void;
  onRemoveMembersFromSegmentClick: () => void;
};

export const SegmentAssignMemberships = ({
  shouldDisableControls,
  membershipInputValue,
  onMembershipInputChange,
  onAddMembersToSegment,
  onRemoveMembersFromSegmentClick,
}: SegmentAssignMembershipsProps) => {
  return (
    <Stack>
      <Grid container spacing={3}>
        <Grid sm xs={12}>
          <TextField
            label='Add one Membership ID at a time, or a comma separated list of up to 100 Membership IDs'
            fullWidth
            margin='none'
            value={membershipInputValue}
            onChange={(e) => onMembershipInputChange(e.target.value)}
            disabled={shouldDisableControls}
          />
        </Grid>

        <Grid display='flex' justifyContent='center' alignItems='center'>
          <Button
            variant='contained'
            color='primary'
            onClick={onAddMembersToSegment}
            disabled={shouldDisableControls || membershipInputValue.length === 0}
          >
            Add
          </Button>

          <Button
            variant='contained'
            color='error'
            sx={{
              marginLeft: 3,
            }}
            onClick={onRemoveMembersFromSegmentClick}
            disabled={shouldDisableControls || membershipInputValue.length === 0}
          >
            Remove
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
};
